import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserInterface } from './../models/user.model';
import { map, tap, distinctUntilChanged, take } from 'rxjs/operators';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { JwtService } from './jwt.service';
import { Apollo } from 'apollo-angular';
import { LoginGQL, MeGQL } from '../graphql';
import { ErrorHandlingService } from './error-handling.service';
// import { Store } from '@ngrx/store';
import * as Sentry from '@sentry/browser';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private currentUserSubject = new BehaviorSubject<UserInterface>(
        {} as UserInterface,
    );
    public currentUser = this.currentUserSubject
        .asObservable()
        .pipe(distinctUntilChanged());

    private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
    public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

    private userGroupSubject = new ReplaySubject<string>(1);
    public userGroup$ = this.userGroupSubject.asObservable();

    constructor(
        private apollo: Apollo,
        private jwtService: JwtService,
        private router: Router,
        private loginGQL: LoginGQL,
        private meGQL: MeGQL,
        private errorHandlingService: ErrorHandlingService,
    ) {}

    attemptAuth({ credentials }): Observable<any> {
        return this.loginGQL
            .mutate({
                email: credentials.email,
                password: credentials.password,
            })
            .pipe(
                map(response => response.data.login),
                // skipWhile(data === null),
                tap((data: UserInterface) => {
                    if (data != null) {
                        this.errorHandlingService.errors.next({});
                        this.setAuth(data);
                    }
                }),
            );
    }

    setAuth(user: UserInterface) {
        this.jwtService.saveToken(user.token);
        this.currentUserSubject.next(user);
        this.isAuthenticatedSubject.next(true);
        this.userGroupSubject.next(user.ruolo ? user.ruolo.nome : 'Cliente');

        Sentry.configureScope(scope => {
            scope.setUser({ email: user.email, username: user.username });
        });
    }

    async purgeAuth() {
        this.router.navigateByUrl('login');
        this.jwtService.destroyToken();
        this.currentUserSubject.next({} as UserInterface);
        this.isAuthenticatedSubject.next(false);
        this.userGroupSubject.next('cliente');
        window.localStorage.setItem('layout', 'grid');
        window.localStorage.setItem('fluid', 'false');
        window.localStorage.setItem('limit', '10');
        window.localStorage.setItem('isNavbarOpen', 'false');
        this.errorHandlingService.errors.next([]);

        await this.apollo.getClient().resetStore();
    }

    populate() {
        if (this.jwtService.getToken()) {
            this.meGQL
                .watch({}, { fetchPolicy: 'network-only' })
                .valueChanges.pipe(take(1))
                .subscribe(
                    response => {
                        if (!response.errors) {
                            this.setAuth((<any>response).data.me);
                        } else {
                            console.log(response.errors);
                            this.purgeAuth();
                            throw new Error('Token non valido');
                        }
                    },
                    err => {
                        console.log(err);
                        this.purgeAuth();
                        throw new Error('Token non valido');
                    },
                );
        } else {
            this.purgeAuth();
        }
    }
}
